export const apiurls = {
  //API URLS to be entered here
  Login: "/login",
  ResetPassword: "/reset-password",
  ForgotPassword: "/forgot-password",
  Logout: "/logout",
  Registration: "/api/registration",
  GetCountry: "/get-countries",
  GetUni: "/get-universities?country_code=US",
  CodeValid: "/api/book-code-validation",
  ValidEmail: "/api/validate-email",
  ValidUsername: "/api/check-username",
  GenCodeApi:"/generate-codes",
  FlashcardQuestions: "/get-flashcard",
  ResourceList:'/get-resource-list',
  ValidateToken: "/validate-token",
  AnswerTest:"/answer-test",
  TakeTest:"/take-test",
  UserDetails: "/api/get-user-details",
  UserList: "/get-user-list",
  Feedback: "/feedback",
  ResourceDetails: "/get-resource-details",
  UpdateUsers: "/api/update-user-details/",
  ActivationValidity: "/api/check-activation-validity/",
  ResendActivationValidity: "/api/resend-activation-link",
  ContactUs: "/contact-us",
  GetImageQuiz: "/get-image-quiz",
  GetQuestions: "/get-questions",
  GetQuestionDetails:"/get-question-details",
  UpdateQuestion:"/update-question",
  AnswerQuiz: "/answer-image-quiz",
  TestScore: "/test-score",
  FlashCardView: "/get-flashcard",
  UpdateFlashCard: "/flashcards",
  MyScores:"/api/my-scores",
  TestResults:"/test-results",
  GetStates: "/get-states",
  GetStateUni : "/get-universities",
  ReviewIncorrect:"/review-incorrect",
  VesPdf: "/download-ves",
  ResendEmail: "/resend_email",
	ResourceUpdate: "/update-resource",
  AdminDashboard:"/get-dashboard-data",
  FeedbackGiven: "/is-feedback-given/",
  GetVideo : "/get-video",
  DownloadTestQuestions: "/download-test-questions",
  FeedbackAnalysis: "/feedback-analysis",
  UniversityListing: "/university-master-list",
  AddUniversity: "/add-new-university",
  AddResource: "/add-resource",
  GetConsentDocuments: "/get-consent-documents",
  UploadDocuments: "/upload-documents",
  GetDoc: "/get-document/",
  SettingsDetails: "/get-settings-details",
  SaveSettings: "/update-settings-details",
  CronSettings: "/crons/get-cron-settings",
  ExportListingData: "/export-data"
}